export const getTags = (flyers, audienceTags = []) => {
  const tagNames = [];
  flyers.forEach((flyer) => {
    if (flyer.intendedAudienceTags && flyer.intendedAudienceTags.length > 0) {
      flyer.intendedAudienceTags.forEach((tagId) => {
        const tag = audienceTags.find((t) => t.id === tagId);
        if (tag && tag.name && tag.name !== "") {
          tagNames.push(tag.name);
        }
      });
    }
  });
  return tagNames;
};

export const filterTags = (tags) => {
  //return unique tags
  return [...new Set(tags)];
};

export const filterFlyers = (flyers, tagName, audienceTags = []) => {
  if (!tagName || tagName === "All") {
    return flyers;
  }

  // Find the tag ID that corresponds to the selected tag name
  const tagObject = audienceTags.find((tag) => tag.name === tagName);
  if (!tagObject) return flyers;

  const tagId = tagObject.id;

  const filteredFlyers = flyers.filter((flyer) => {
    return (
      flyer.intendedAudienceTags && flyer.intendedAudienceTags.includes(tagId)
    );
  });

  return filteredFlyers;
};